import Vue from 'vue'
import { CANDict, Vehicle } from '@/models'
import OverviewTab from './OverviewTab.vue'
import UsageTab from './UsageTab.vue'
import VariablesTab from './VariablesTab.vue'
import DeactivateTab from './DeactivateTab.vue'

export default new Vue({
  data() {
    return {
      id: null,
      row: null,
      usage: null,
      originalStr: null
    }
  },
  computed: {
    tabItems() {
      return [
        { value: 'overview', label: 'Geral', component: OverviewTab },
        { value: 'variables', label: 'Variáveis', component: VariablesTab },
        { value: 'usage', label: 'Utilização', component: UsageTab },
        { value: 'deactivate', label: 'Desativar', component: DeactivateTab }
      ]
    },
    isDirty() {
      return JSON.stringify(this.row) != this.originalStr
    }
  },
  methods: {
    async load(id) {
      this.id = id
      this.row = null
      const row = await CANDict.findById(id)
      const vehicles = await Vehicle.findByConfig({
        key: 'canDictId',
        value: id
      })
      // NB: Por enquanto trazemos apenas "os veículos associados
      // a este canDictId", mas não trazemos quais vars eles usam.
      // const usage = await computeUsage(row, vehicles)
      const usage = vehicles

      this.originalStr = JSON.stringify(row)
      this.row = row
      this.usage = usage
    },

    async fetchVariable(varId) {
      if (varId == null) return {}
      return CANDict.getVariable(this.row.id, varId)
    },

    async patch(body) {
      await CANDict.patch(this.row.id, body)
      await this.load(this.row.id)
    },

    async updateVariable(body) {
      if (body.id == null) {
        await CANDict.createVariable(this.row.id, body)
      } else {
        await CANDict.updateVariable(this.row.id, body.id, body)
      }
      await this.load(this.row.id)
    },

    async deactivate() {
      await CANDict.delete(this.row.id)
      await this.load(this.row.id)
    }
  }
})
